import { CSSProperties } from "react";

export function displayIf(show: boolean): CSSProperties {
    return {
        display: show ? "block" : "none",
    };
}
